enum CommunityMemberStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Inactive = 'Inactive',
}
export default CommunityMemberStatus;
